import React, { useEffect, useState } from 'react';
import { ActivityIndicator, FlatList, ScrollView, View } from 'react-native';
import { useDispatch, useSelector } from "react-redux"
import Colors from '../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { event_bulkGetAthletes, event_getAthletesByLeagueId, event_getMatchesByTournamentId, event_getTournamentByTournamentId, event_loadExternalPrices, event_updateTournament } from '../../store/actionsv1/events';
import { MarketProps } from '../../store/types/mk_svc';
import { market_getMarketsFromSupportedMarkets } from './helpers/markets';
import AthleteMarketCard from './components/AthleteMarketCard';
import TournamentInfoCard from './components/TournamentInfoCard';
import { LoadPriceRequestType, MatchProps, TournamentProps } from '../../store/types/sr_svc';
import MatchMarketCard from './components/MatchMarketCard';
import TeamMarketCard from './components/TeamMarketCard';
import { market_getLatestTradesByEventId, market_getOrderStatsByEvent } from '../../store/actionsv1/markets';
import moment from 'moment';
import { PublicPlayerProps } from '../../store/types/auth_svc';
import { Icon } from 'react-native-elements';

const TournamentScreen = ({ route, navigation }:any) => {
    const [ loaded, setLoaded ] = useState(false);
    const [ participant_offset, setParticipantOffset ] = useState(1)
    const [ toggle_box_width, setToggleBoxWidth ] = useState(0)
    const [ active_market, setActiveMarket ] = useState<MarketProps | undefined>()
    const dispatch = useDispatch();

    const player:PublicPlayerProps|undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const markets = useSelector((state:any) => state.market.markets, (left, right) => left.length === right.length)
    const leagues = useSelector((state:any) => state.event.leagues, (left, right) => left.length === right.length)
    const tournament:TournamentProps = useSelector((state:any) => state.event.tournaments[route.params.tournament_id], (left, right) => { 
        if(left?.tournament_id != right?.tournament_id) return false
        if(left?.status != right?.status) return false
        if(left && right && left.participants.length != right.participants.length){ return false }
        return true
    })
    const close_markets = tournament?.status === 'closed' ? true : false
    const matches_dict: { [key:string]: MatchProps } = useSelector((state:any) => state.event.matches, (left, right) => left == right);
    const matches = Object.values(matches_dict).filter((m:MatchProps) => m.tournament_id == route.params.tournament_id && m.status != 'closed')
    
    let available_tournament_markets = market_getMarketsFromSupportedMarkets(tournament?.supported_markets??[], markets)

    useEffect(() => {
        getDataFromServer(route.params.tournament_id)
    },[route.params.tournament_id])

    useEffect(() => {
        setActiveMarket(available_tournament_markets[0])
    },[available_tournament_markets.length])

    useEffect(() => {
        if(!tournament?.league_id){ return setLoaded(true) }
        if(tournament.participant_type === 'athlete'){ getAthletesFromServer() }
    },[tournament?.league_id])

    const getDataFromServer = async(tournament_id:string) => {
        if(!tournament){ await dispatch(event_getTournamentByTournamentId(tournament_id))}
        await dispatch(event_getMatchesByTournamentId(tournament_id))
        await dispatch(market_getLatestTradesByEventId(route.params.tournament_id, 'tournament'))
        await dispatch(market_getOrderStatsByEvent(route.params.tournament_id, 'tournament'))
        setLoaded(true)
    }

    const handleCloseTournament = async() => {
        if(!tournament){ return }
        await dispatch(event_updateTournament({ ...tournament, status:'closed' }))
    }

    const getAthletesFromServer = async() => {
        dispatch(await event_bulkGetAthletes(tournament.participants))
        setLoaded(true)
    }

    const handleLoadPrices = async() => {
        if(!player || player.role !== 'admin'){ return }
        if(!tournament.supported_markets || tournament.supported_markets.length === 0){ return alert('There are no supported markets available for tournament') }
        if(!active_market){ return alert('No market') }
        let price_request:LoadPriceRequestType = {
            event_id: route.params.tournament_id,
            event_type: 'tournament',
            level: active_market.level,
            market_ids: [ active_market.market_id ],
            activate: true
        }
        await dispatch(event_loadExternalPrices(price_request))
    }

    const handleUpdateTournamentParticipants = async(participant_id:string) => {
        if(!tournament){ return }
        await dispatch(event_updateTournament({ ...tournament, participants: tournament.participants.filter(p => p != participant_id) }))
    }

    const renderParticipants = (data: {item: {participant_id:string, market:MarketProps}, index:number}) => {
        if(tournament.participant_type === 'athlete'){
            return (
                <View style={{ margin:4 }}>
                    <AthleteMarketCard do_not_load_athlete navigation={navigation} close_markets={close_markets} market_override={data.item.market} athlete_id={data.item.participant_id} event_type='tournament' event_id={tournament.tournament_id}/>
                    {player?.role == 'admin' ?
                    <View style={{ padding:10 }}>
                        <TouchableOpacity onPress={() => handleUpdateTournamentParticipants(data.item.participant_id)}>
                            <Text size={12} color={Colors.utility.error}>Remove Participant</Text>
                        </TouchableOpacity>
                    </View>
                    :<></>}
                </View>
            )
        } 
        return (
            <View style={{ margin:4 }}>
                <TeamMarketCard navigation={navigation} close_markets={close_markets} market_override={data.item.market} team_id={data.item.participant_id} event_type='tournament' event_id={tournament.tournament_id} />
                {player?.role == 'admin' ?
                <View style={{ padding:10 }}>
                    <TouchableOpacity onPress={() => handleUpdateTournamentParticipants(data.item.participant_id)}>
                        <Text size={12} color={Colors.utility.error}>Remove Participant</Text>
                    </TouchableOpacity>
                </View>
                :<></>}
            </View>
        )
    }
    const renderMarkets = (data: { item: MarketProps, index:number }) => {
        const active = active_market?.market_id == data.item.market_id ? true : false
        return (
            <TouchableOpacity style={{ width:toggle_box_width/available_tournament_markets.length, padding:12, justifyContent:'center', alignItems:'center',
                borderRadius:5, backgroundColor:active?Colors.shades.white : 'transparent', shadowColor: active ?"rgba(0, 0, 0, 0.2)": 'transparent', 
                shadowOffset: { width: 0, height: 1 }, shadowRadius: 0, shadowOpacity: 1 }}
                onPress={() => setActiveMarket(data.item)}
            >
                <Text>{data.item.type === 'Stat'?data.item.description:data.item.type}</Text>
            </TouchableOpacity>
        )
    }
    const renderMatches = ( data: {item:MatchProps, index:number} ) => {
        return (
            <View style={{ margin:4 }}>
                <MatchMarketCard navigation={navigation} match_id={data.item.match_id}/>
            </View>
        )
    }
    if(!loaded || !tournament){
        return (
            <View style={{ padding:10, justifyContent:'center', alignItems:'center' }}>
                <ActivityIndicator size='large' color={Colors.brand.midnight} />
            </View>
        )
    }
    const league = leagues.find(l => l.league_id == tournament.league_id)
    const participants = tournament.participants.slice(0,participant_offset*10)
    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <ScrollView style={{ flex:1, paddingBottom:75 }}>
                <TournamentInfoCard tournament={tournament} league={league}/>
                {available_tournament_markets.length > 0?
                <View nativeID='tournament_markets' style={{ flex:1, padding:2, margin:5, marginRight:20, marginLeft:20, flexDirection:'row', borderRadius: 6, backgroundColor: '#e9e9e9' }} onLayout={(ev) => {
                    const { width } = ev.nativeEvent.layout;
                    setToggleBoxWidth(width)
                }}>
                    <FlatList data={available_tournament_markets} renderItem={renderMarkets} keyExtractor={(item) => item.market_id.toString()} horizontal/>
                </View>
                :<></>}
                {available_tournament_markets.length === 0 && matches.length === 0 && participants.length  > 0 ?
                <View style={{ justifyContent:'center', alignItems:'center' }}>
                    <Text size={14} color={Colors.brand.midnight} weight='bold' textAlign='center'>No markets are active.  Please check back again later</Text>
                </View>
                :<></>}
                {matches.length === 0 ?
                <View nativeID='tournament_participants'>
                    <FlatList data={participants.map(p => { return { participant_id:p, market:active_market }})} renderItem={renderParticipants} keyExtractor={(item) => item.participant_id.toString()}/>
                </View>
                :<></>}
                <View nativeID='matches'>
                    <FlatList data={matches.sort((a,b) => moment(a.scheduled_datetime).unix() - moment(b.scheduled_datetime).unix())} renderItem={renderMatches} keyExtractor={(item) => item.match_id.toString()}/>
                </View>
                {participants.length === 0 && matches.length === 0 ?
                <View style={{ justifyContent:'center', alignItems:'center' }}>
                    <Text size={14} color={Colors.brand.midnight} weight='bold' textAlign='center'>The field is not yet set. Please check again later.</Text>
                </View>
                :<></>}
                {available_tournament_markets.length > 0 && participants.length > 0 && participants.length < tournament.participants.length ?
                <TouchableOpacity style={{ margin:10, marginTop:20, borderWidth:1, borderRadius:4, borderColor:Colors.brand.midnight }} onPress={() => setParticipantOffset(participant_offset+1)}>
                    <Text size={14} color={Colors.brand.midnight} style={{ padding:5 }} weight='semibold' textAlign='center'>LOAD MORE</Text>
                </TouchableOpacity>
                :<></>}
            </ScrollView>
            {player?.role === 'admin' ?
            <View style={{  position:'absolute', bottom:10, left:10, }}>
                <TouchableOpacity style={{ flexDirection:'row', alignItems:'center',  borderRadius:20, padding:2, backgroundColor:Colors.brand.electric, shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1  }} onPress={() => handleLoadPrices()}>
                    <View style={{ height:20, width:20, backgroundColor:Colors.shades.white, borderRadius:100, justifyContent:'center', alignItems:'center' }}>
                        <Icon name='refresh-cw' type='feather' color={Colors.brand.electric} size={12} />
                    </View>
                    <Text size={12} color={Colors.shades.white} style={{ margin:5 }}>Load Prices</Text>
                </TouchableOpacity>
                <TouchableOpacity style={{ marginTop:3, flexDirection:'row', alignItems:'center',  borderRadius:20, padding:2, backgroundColor:Colors.brand.electric, shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1  }} onPress={() => handleCloseTournament()}>
                    <View style={{ height:20, width:20, backgroundColor:Colors.shades.white, borderRadius:100, justifyContent:'center', alignItems:'center' }}>
                        <Icon name='x-circle' type='feather' color={Colors.utility.error} size={12} />
                    </View>
                    <Text size={12} color={Colors.shades.white} style={{ margin:5 }}>Close Tournament</Text>
                </TouchableOpacity>
            </View>
            :<></>}
        </View>
    )
}

export default TournamentScreen